import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Button } from "reactstrap";
import WorkoutApi from "../Api";
import ExerciseCard from "../exercises/ExerciseCard";
import "../navbar.css";

const WorkoutPage = () => {
  const { id } = useParams();
  let newUser = JSON.parse(localStorage.getItem("user"));

  const [workouts, setWorkouts] = useState("");
  const [exercises, setExercises] = useState(null);

  useEffect(() => {
    WorkoutApi.getWorkout(newUser.id, id).then((res) => {
      setWorkouts(res);
    });
    WorkoutApi.getWorkoutExercises(newUser.id, id).then((res) => {
      setExercises(res);
    });
  }, [id, newUser.id]);

  return (
    <>
      <h1>Workout Name: {workouts ? workouts.name : ""}</h1>
      <h6>Workout description: {workouts ? workouts.description : ""}</h6>
      <a href={`/exercise/${workouts ? workouts.id : ""}/create`}>
        <Button className="buttonspace" color="primary">
          Add Exercise
        </Button>
      </a>

      {exercises
        ? exercises.map((w) => (
            <ExerciseCard
              key={w.id}
              date={w.date_time}
              w_id={w.workout_id}
              name={w.name_of_exercise}
              description={w.exercise_description}
              e_id={w.exercise_id}
            />
          ))
        : "Loading..."}
    </>
  );
};

export default WorkoutPage;
